const showScrollTop = () => {
    if (document.querySelector('.ume-intra-footer-inner-up-holder')) {
        document.addEventListener('click', ev => {
            if (!ev.target.closest('.ume-intra-footer-inner-up-holder-button')) return;
            // This prevents the page from scrolling down to where it was previously.
            if ('scrollRestoration' in history) {
                history.scrollRestoration = 'manual';
            }
            window.scrollTo(0, 0);
        })
    }
}
export default showScrollTop;